import { useSortable as useKitSortable, type Place } from "@signet/web-kit";

/* The drag lives in the kit now (the onboarding tracker's lines use it too). To-dos keep
   their td- classes, and a press on the name still starts a drag: it opens the to-do on click. */

export type { Place };

const IGNORE = "button:not(.td-name-open), a, input, select, textarea, [role='checkbox'], [contenteditable='true'], .td-cell-select";

export function useSortable(options: Omit<Parameters<typeof useKitSortable>[0], "prefix" | "ignore">) {
  return useKitSortable({ ...options, prefix: "td", ignore: IGNORE });
}
